import { Form, FormInstance, Input, Row } from "antd";
import { FloatNumberInput } from "../../../../../../../../components/FloatNumberInput";
import { useCallback, useMemo } from "react";
import { useGetItemTitleRules } from "./hooks/useGetItemTitleRules";

type TBuyerAmountsProps = {
  form: FormInstance;
};

export const BuyerAmounts = ({ form }: TBuyerAmountsProps) => {
  const AMOUNT_INPUTS_DATA = useMemo(
    () => [
      {
        label: "Principal",
        name: ["buyer", "principal"],
        disabled: true,
      },
      {
        label: "Interest",
        name: ["buyer", "interest"],
      },
      {
        label: "Unpaid Interest",
        name: ["buyer", "unpaidInterest"],
      },
      {
        label: "Unpaid Late Charges",
        name: ["buyer", "unpaidLateCharges"],
      },
      {
        label: "Current Late Charges",
        name: ["buyer", "currentLateCharges"],
      },
      {
        label: null,
        name: ["buyer", "amount"],
      },
    ],
    []
  );

  const inputClassName = useCallback(
    (index: number): string =>
      index === AMOUNT_INPUTS_DATA.length - 1 ? "mb-0" : "mb-2",
    [AMOUNT_INPUTS_DATA]
  );

  const { rules } = useGetItemTitleRules();

  return (
    <Row className="w-100 flex-column">
      <p className="mb-4 mt-0 text-md w-500">Buyer Amounts</p>
      {AMOUNT_INPUTS_DATA.map((item: any, index) => (
        <Row
          className="justify-space-between flex-nowrap w-100"
          key={item.label || "customItem"}
        >
          {!!item.label ? (
            <span className="text-md title pt-1 pr-2">{item.label}</span>
          ) : (
            <Form.Item
              className="flex-grow-1 mr-2 mb-0 payoff-form-item-title"
              name={["item", "title"]}
              rules={rules}
            >
              <Input placeholder="Item Title" />
            </Form.Item>
          )}
          <FloatNumberInput
            {...item}
            form={form}
            label=""
            allowNegative
            includeThousandsSeparator
            className={`payoff-form-amount-input ${inputClassName(index)}`}
          />
        </Row>
      ))}
    </Row>
  );
};
